import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import {
  Calendar as MultiDatePickerCalendar,
  DateObject,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import styled from "styled-components";
import useOutsideClick from "hooks/useOutsideClick";

const Tile = styled.div`
  cursor: pointer;
`;

const Calendar = styled(MultiDatePickerCalendar)`
  position: absolute;
  top: ${(props) => (props.top ? props.top : "44%")};
  left: ${(props) => (props.left ? props.left : "50%")};
  display: ${(props) => (props.show ? "block" : "none")};
`;

const dateObject = new DateObject({ calendar: persian, locale: persian_fa });

const PersianPickerTile = ({ currentDate, topOffset, leftOffset, onPick }) => {
  const compRef = useRef();
  const [showPicker, setShowPicker] = useState(false);

  const getDateLabel = () =>
    currentDate
      ? new DateObject(new Date(currentDate))
        .convert(persian, persian_fa)
        .format()
      : dateObject.format();

  const onDateChange = useCallback(
    (newDate) => {
      onPick?.(
        newDate
          .convert(gregorian, gregorian_en)
          .toUTC()
          .format("YYYY-MM-DDThh:mm:ss.SSS")
      );
      setShowPicker(false);
    },
    [onPick]
  );

  useOutsideClick(compRef?.current, () => {
    setShowPicker(false);
  });

  const renderCalendar = useCallback(
    () => (
      <Calendar
        show={showPicker}
        calendar={persian}
        locale={persian_fa}
        onChange={onDateChange}
        top={topOffset}        
        left={leftOffset}
        value={new Date(currentDate)}
        maxDate={dateObject}
      />
    ),
    [showPicker, leftOffset, onDateChange, currentDate]
  );

  return (
    <div ref={compRef}>
      <Tile onClick={() => setShowPicker(true)}>
        <FaCalendarAlt size={12} className="me-2" />
        <span> {getDateLabel()}</span>
      </Tile>
      {renderCalendar()}
    </div>
  );
};

export default PersianPickerTile;
